import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";

import PostApi from "api/postApi";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import CollapseFilter from "components/Common/CollapseFilter";
import DatePickerCustom from "components/Common/DatePickerCustom";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import ModalPreview from "components/Common/ModalPreview";
import TooltipCustom from "components/Common/TooltipCustom";
import { useRole } from "components/Hooks/UserHooks";
import {
  COLOR_HASHTAG_STATUS,
  HASHTAG_STATUS_OPTION,
} from "helpers/constans";
import {
  formatDateStringToKorea,
} from "helpers/format";
import CountUp from "react-countup";
import CreateEditWink from "./HashTagForm";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import BarListDetail from "pages/BarList/BarListDetail";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import { getHashTags } from "store/hashtag/thunk";
import hashTagApi from "api/hashTagApi";
import { ColorPicker } from "antd";

export interface Tag {
  id: string;
  text: string;
}

registerLocale("en", en);
registerLocale("ko", ko);

const HashTag = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    keyword: withDefault(StringParam, ""),
    group_name: withDefault(StringParam, ""),
    hashtag: withDefault(StringParam, ""),
    status: withDefault(StringParam, ""),
    created_from: withDefault(StringParam, ""),
    created_to: withDefault(StringParam, ""),

    sort_by: withDefault(StringParam, "created_at"),
    order_by: withDefault(StringParam, "DESC"),
  });

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [itemToEdit, setItemToEdit] = useState<any>(false);
  const [itemToBarDetail, setItemToBarDetail] = useState<any>(null);

  const [keywordSearch, setKeywordSearch] = useState<string>(
    query?.keyword || ""
  );
  const [groupNameSearch, setGroupNameSearch] = useState<string>(
    query?.group_name || ""
  );
  const [hashTagSearch, setHashTagSearch] = useState<string>(
    query?.hashtag || ""
  );
  const [statusSearch, setStatusSearch] = useState<any>(
    HASHTAG_STATUS_OPTION?.find(
      (item) => (item?.value) === ((query?.status))
    )?.value || ''
  );

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.created_from
      ? moment(query?.created_from || "", "Y-MM-DD").toDate()
      : null,
    query?.created_to ? moment(query?.created_to || "", "Y-MM-DD").toDate() : null,
  ]);
  const [created_from, created_to] = dateSearch;

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.HashTag;

  const HashTagProperties = createSelector(selectLayoutState, (state) => ({
    hashTags: state.hashTags,
    isHashTagLoading: state.isHashTagLoading,
    isHashTagSuccess: state.isHashTagSuccess,

    error: state.error,
  }));

  // Inside your component
  const { hashTags, isHashTagLoading } = useSelector(HashTagProperties);

  function loadTableData() {
    dispatch(getHashTags(query));
  }

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  const [linkImage, setLinkImage] = useState<any>(null);
  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  const searchData = () => {
    setQuery({
      ...query,
      group_name: encodeURIComponent(groupNameSearch.trim()) || "",
      hashtag: encodeURIComponent(hashTagSearch.trim()) || "",
      status: statusSearch,
      created_from: created_from
        ? (new Date(moment(created_from).startOf("day").format("Y-MM-DD HH:mm:ss"))).toISOString()
        : "",
      created_to: created_to ? (new Date(moment(created_to).endOf("day").format("Y-MM-DD HH:mm:ss"))).toISOString() : "",
      sort_by: "created_at",
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        group_name: "",
        hashtag: "",
        status: "",
        created_from: "",
        created_to: "",
        sort_by: "created_at",
        time_request: +new Date(),
        page: 1,
      },
      "push"
    );
    setHashTagSearch((_prev) => "");
    setGroupNameSearch((_prev) => "");
    setStatusSearch((_prev: any) => "");
    setDateSearch([null, null]);
  };

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  // Begin::Change status
  const handleOnConfirmUpdate = async (item: {
    id: number | string;
    status: string | boolean;
  }) => {
    try {
      if (!item) {
        return;
      }
      const response: any = await hashTagApi?.putHashTag(item?.id, {
        status: item?.status,
      });

      if (response?.data) {
        // setItemUpdate((_prev) => null);
        loadTableData();
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };
  // End::Change status

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 80,
        thClass: "whitespace-nowrap",
        Cell: ({ ...props }) => {
          return (
            <div>
              {hashTags?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "status",
        thWidth: 80,
        filterable: false,
        sortable: false,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <div
              className="form-check form-switch form-switch-sm text-center"
              dir="ltr"
            >
              <input
                type="checkbox"
                className="form-check-input"
                name="status"
                id="customSwitchsizelg"
                checked={item?.status === 1}
                onChange={(e) => {
                  const value = e?.target?.checked;
                  handleOnConfirmUpdate({
                    id: item?.id,
                    status: !!value ? "1" : "0",
                  });
                }}
              />
            </div>
          );
        },
      },

      {
        Header: t("Group Name"),
        accessor: "name",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          const row = cell?.row?.original;
          return cell?.value && (
            <>
              <div
                className="cursor-pointer"
                style={{
                  width: "180px",
                }}
              >
                {cell?.value}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Name Color"),
        accessor: "name_color",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 150,
        Cell: (cell: any) => {
          const color = cell?.row?.original?.name_color;
          return (
            <ColorPicker
              defaultValue="#1677ff"
              showText
              allowClear
              value={color}
              disabled
            />
          );
        },
      },
      {
        Header: t("Normal Text Color"),
        accessor: "normal_text_color",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const color = cell?.row?.original?.normal_text_color;
          return (
            <ColorPicker
              defaultValue="#1677ff"
              showText
              allowClear
              value={color}
              disabled
            />
          );
        },
      },
      {
        Header: t("Normal Background Color"),
        accessor: "normal_background_color",
        filterable: true,
        sortable: false,
        thWidth: i18n?.language === 'en' ? 200 : 150,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const color = cell?.row?.original?.normal_background_color;
          return (
            <ColorPicker
              defaultValue="#1677ff"
              showText
              allowClear
              value={color}
              disabled
            />
          );
        },
      },
      {
        Header: t("Selected Text Color"),
        accessor: "active_text_color",
        filterable: true,
        sortable: false,
        thWidth: i18n?.language === 'en' ? 180 : 150,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const color = cell?.row?.original?.active_text_color;
          return (
            <div className="d-block">
              <ColorPicker
                defaultValue="#1677ff"
                showText
                allowClear
                value={color}
                disabled
              />
            </div>
          );
        },
      },
      {
        Header: t("Selected Background Color"),
        accessor: "active_background_color",
        filterable: true,
        sortable: false,
        thWidth: i18n?.language === 'en' ? 220 : 150,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const color = cell?.row?.original?.active_background_color;
          return (
            <div className="d-block">
              <ColorPicker
                defaultValue="#1677ff"
                showText
                allowClear
                value={color}
                disabled
              />
            </div>
          );
        },
      },
      {
        Header: t("Hashtags"),
        accessor: "hashtags",
        filterable: false,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 300,
        Cell: (cell: any) => {
          const textColor = cell?.row?.original?.normal_text_color;
          const bgColor = cell?.row?.original?.normal_background_color;
          const allKeyword = cell?.value;
          let shortKeyword = [];

          if (allKeyword?.length > 2) {
            shortKeyword = [...allKeyword].splice(0, 8);
          } else {
            shortKeyword = allKeyword;
          }

          const [isShowMore, setIsShowMore] = useState(false);

          const showData = isShowMore ? allKeyword : shortKeyword;

          return (
            allKeyword?.length > 0 && (
              <div>
                <div className="d-flex gap-1" style={{ flexWrap: 'wrap', minWidth: 280 }}>
                  {showData?.map((item: any, index: number) => {
                    let tagName: string = "";

                    tagName += `${item ? `${item}` : ""
                      }`;

                    return (
                      <span
                        dangerouslySetInnerHTML={{ __html: tagName }}
                        key={index}
                        className="tag-style"
                        style={({ backgroundColor: bgColor, borderColor: bgColor, color: textColor })}
                      />
                    );
                  })}
                </div>

                {allKeyword?.length > 2 && (
                  <span
                    onClick={(e) => {
                      e.preventDefault();
                      setIsShowMore((prev) => !prev);
                    }}
                    style={{
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    }}
                    className="link-primary fs-12 d-inline"
                  >
                    <span>{isShowMore ? t("View Less") : t("View More")}</span>
                    <i
                      className={`${isShowMore
                          ? "ri-arrow-up-s-line"
                          : "ri-arrow-down-s-line"
                        } fs-16 position-relative`}
                      style={{ top: "4px" }}
                    ></i>
                  </span>
                )}
              </div>
            )
          );
        },
      },
      {
        Header: t("Created at"),
        accessor: "created_at",
        filterable: false,
        sortable: false,
        thWidth: 150,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end pe-3" style={{ minWidth: "120px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Updated at"),
        accessor: "updated_at",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Button Action"),
        thClass: "text-center",
        thWidth: 150,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline d-flex flex-wrap hstack gap-2 mb-0"
              style={{ width: "120px", justifyContent: "center" }}
            >
              <TooltipCustom
                title={t("Button Update")}
                id={`update-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-primary edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsOpen(true);
                    setItemToEdit(item);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom "></i>
                </Link>
              </TooltipCustom>

              <TooltipCustom
                title={t("Button Delete")}
                id={`delete-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-danger edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setItemToDelete(item);
                  }}
                >
                  <i className="ri-delete-bin-3-fill align-bottom"></i>
                </Link>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, hashTags?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Begin::Delete

  const handleActionDelete = async (id: any) => {
    if (!id) {
      return;
    }
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await hashTagApi?.deleteHashTag(id);
      if (response?.code === 200) {
        loadTableData();
        setIsConfirmLoading((_prev) => false);
        setItemToDelete(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  // End::Delete

  const handleCloseModalBarDetail = () => {
    setItemToBarDetail(null);
  };

  useEffect(() => {
    document.title = `${t("Hashtag")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Hashtag")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="hashtagList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={hashTags?.pagination?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                    <div className="col-sm-auto text-end">
                      <button
                        type="button"
                        className="btn btn-success d-md-block"
                        onClick={() => {
                          setIsOpen(true);
                          setItemToEdit(null);
                        }}
                      >
                        <i className="ri-add-fill align-bottom me-1"></i>{" "}
                        {t("Button Create Hashtag")}
                      </button>
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-md-2 mt-0">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Group Name")}`}
                          isShow={!!groupNameSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Group Name")}...`}
                            value={groupNameSearch}
                            onChange={(e) => setGroupNameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Hashtag")}`}
                          isShow={!!hashTagSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Hashtag")}...`}
                            value={hashTagSearch}
                            onChange={(e) => setHashTagSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={HASHTAG_STATUS_OPTION || []}
                            placeholder={`${t("Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(event: any) => {
                              console.log(event?.value)
                              setStatusSearch(event?.value);
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_HASHTAG_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-3 mt-md-2 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!created_from || !!created_to}
                        >
                          <DatePickerCustom
                            startDate={created_from || null}
                            endDate={created_to || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={12}
                        xl={12}
                        xxl={12}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-3 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                            disabled={isHashTagLoading}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed sticky-table-feed-media"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={hashTags?.items?.length ? hashTags?.items : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={hashTags?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(hashTags?.pagination?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isHashTagLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {itemToDelete && (
          <ModalConfirm
            header={t("Delete Hashtag")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}

        {isOpen && (
          <CreateEditWink
            setIsOpen={setIsOpen}
            item={itemToEdit}
            setItemToEdit={setItemToEdit}
            loadTableData={loadTableData}
            linkImage={linkImage}
            setLinkImage={setLinkImage}
            onCloseImageClick={onCloseImageClick}
          />
        )}

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        {itemToBarDetail && (
          <Modal
            isOpen={!!itemToBarDetail}
            centered={true}
            size="xl"
            className="modal-fullscreen"
            scrollable={false}
          >
            <ModalHeader toggle={handleCloseModalBarDetail}>
              {itemToBarDetail?.title || ""}
            </ModalHeader>
            <ModalBody>
              <BarListDetail
                barID={itemToBarDetail?.id}
                setLinkImage={setLinkImage}
              // isShowDetail={true}
              />
            </ModalBody>
          </Modal>
        )}

      </div>
    </React.Fragment>
  );
};

export default HashTag;
